import React, { useEffect, useRef } from 'react';
import useMobileLayout from 'Hooks/useMobileLayout';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { noop } from 'Helpers/PropTypes';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { FDDialog, FDDialogContent } from '@facet-wealth/design';
import {
  useYodleeLinkContext,
} from 'Views/Onboarding/Pages/Survey/SurveyStep/Components/AggregatorButtonPicker/Yodlee/YodleeLinkContext';

const useStyles = buildUseStyles('YodleeNewLinkModal', theme => ({
  fastLinkParentDesktop: {
    // Blake Pucsek and James Costian tried but could not get this to work any other way. The iframe is messing things up.
    // theme.dimensions.lg happens to match the maxWidth of FDDialog.
    // theme.spacing(8) is subtracted because FDDialogContent adds theme.spacing(4) worth of padding to the left and right
    width: `calc(${theme.dimensions.lg}px - ${theme.spacing(8)}px)`,
  },
  fastLinkParent: {
    display: 'flex',
    justifyContent: 'center',

    minHeight: '670px',

    '& #container-fastlink': {
      width: '100%',
    },
  },
}));

function YodleeNewLinkModal({
  onClose,
  institutionResource,
}) {
  const classes = useStyles();
  const isMobile = useMobileLayout();

  const {
    showConnectView,
    handleClick,
  } = useYodleeLinkContext();

  // When the resource changes, start yodlee
  useEffect(() => { handleClick(); }, [institutionResource, handleClick]);

  const hasRenderedBefore = useRef(false);
  useEffect(() => {
    if (!hasRenderedBefore.current) {
      // This is the first time rendering, so showConnectView can be false because it hasn't yet rendered
      hasRenderedBefore.current = true;
    } else if (!showConnectView) {
      // At this point, this component has already been rendered before, and showConnectView has changed - time to close this modal
      onClose();
    }
  }, [showConnectView, onClose]);

  return (
    <FDDialog
      fullScreen={isMobile}
      open
      onClose={onClose}
    >
      <FDDialogContent>
        <div className={classNames(classes.fastLinkParent, {
          [classes.fastLinkParentDesktop]: !isMobile,
        })}
        >
          <div id="container-fastlink" />
        </div>
      </FDDialogContent>
    </FDDialog>
  );
}

YodleeNewLinkModal.propTypes = {
  onClose: PropTypes.func,
  institutionResource: PropTypes.object.isRequired,
};

YodleeNewLinkModal.defaultProps = {
  onClose: noop,
};

export default YodleeNewLinkModal;
